var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table-lite',{attrs:{"striped":"","outlined":"","hover":"","fields":_vm.fields,"items":_vm.items,"tbody-tr-class":_vm.rowClass,"thead-class":"table_header"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }